import React from 'react';
import { LogOut, Bell, Sun, Moon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Header({ darkMode, setDarkMode, toggleSidebar, notifications = 3 }) {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center justify-content-between border-bottom p-4 bg-white sticky-top" style={{ zIndex: 1050 }}>
      {/* 📱 Sidebar Toggle Button for Mobile */}
      <button 
        className="btn btn-outline-secondary d-md-none"
        onClick={toggleSidebar}
      >
        ☰
      </button>

      {/* 🏨 Hotel Name */}
      <div className="flex-grow-1 ms-3 me-3 text-truncate">
        <h4 className="m-0 fw-bold" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          Transcorp Hilton International
        </h4>
      </div>
      {/* 🔧 Right Side Icons */}
      <div className="d-flex align-items-center gap-3 flex-shrink-0">
        
        {/* 🌗 Dark/Light Mode Toggle */}
        <button 
          onClick={() => setDarkMode(!darkMode)} 
          className="btn btn-light btn-sm d-flex align-items-center justify-content-center"
        >
          {darkMode ? <Sun size={18} /> : <Moon size={18} />}
        </button>

        {/* 🔔 Notifications with badge */}
        <div className="position-relative">
          <button className="btn btn-light btn-sm">
            <Bell size={18} />
          </button>
          {notifications > 0 && (
            <span 
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style={{ fontSize: '0.7rem' }}
            >
              {notifications}
            </span>
          )}
        </div>

        {/* 👤 Profile button */}
        <button className="btn btn-light btn-sm">Profile</button>

        {/* 🚪 Logout */}
        <button 
          className="btn btn-outline-danger btn-sm d-flex align-items-center"
          onClick={() => navigate('/')}
        >
          <LogOut size={16} className="me-1" />
          Logout
        </button>
      </div>
    </div>
  );
}
